import { render, staticRenderFns } from "./EducationalGroupAttendanceInfo.vue?vue&type=template&id=50e66515&"
import script from "./EducationalGroupAttendanceInfo.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupAttendanceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports